// @flow

export const SET_ERROR: 'ERROR.SET_ERROR' = 'ERROR.SET_ERROR';
export const CLEAR_ERROR: 'ERROR.CLEAR_ERROR' = 'ERROR.CLEAR_ERROR';